<template>
  <div class="orgAssessPageNew">
    <p class="fgx"></p>
    <div class="swiperHeader clearfix">
      <p>考核排名</p>
      <div class="selectPositionBox" @click="changeLocation">
        <van-icon name="location" />{{ locationAddress }}
      </div>
      <div class="selectTimes" @click="checkOrgPicker">
        {{ selectListInfo }}<van-icon name="play" class="sanjiao" />
      </div>
    </div>
    <div class="effectRanking">
      <div class="rankTop">
        <div class="rankTop">
          <van-list
            v-model="loading"
            :finished="finished"
            @load="onLoad"
            :offset="100"
            :finished-text="allRankList[0] ? '没有更多了' : ''"
            class="listBox"
          >
            <van-cell
              v-for="(item, index) in allRankList"
              :key="index"
              class="topListInfo clearfix"
            >
              <p class="fl tit">
                <span v-if="parseFloat(index) < 3"
                  ><img
                    :src="baseUrl + 'topOne.png'"
                    alt=""
                    v-if="index == '0'" />
                  <img
                    :src="baseUrl + 'topTwo.png'"
                    alt=""
                    v-if="index == '1'" />
                  <img
                    :src="baseUrl + 'topThree.png'"
                    alt=""
                    v-if="index == '2'"
                /></span>
                <span v-else>{{ index + 1 }}</span>
              </p>
              <div class="progressBox fl">
                <p>
                  <em>{{ item.name }}</em>
                </p>
                <van-progress
                  :percentage="`${
                    parseFloat(item.score) > 100 ? 100 : parseFloat(item.score)
                  }`"
                  :show-pivot="false"
                  track-color="#D7F3E3"
                  color="#37C375"
                  class="vanProgress clearfix"
                ></van-progress>
              </div>

              <span class="itemPoints">{{ item.score }}分</span>
            </van-cell>
          </van-list>
          <div class="nonePage" v-if="!allRankList[0] && finished">
            <img :src="nonePng" alt />
            <p>暂无数据</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹出框 -->
    <!-- 考核选择 -->
    <van-popup v-model="listPickerShow" position="bottom" round>
      <van-picker
        title="请选择"
        show-toolbar
        :columns="listData"
        value-key="name"
        @confirm="onListConfirm"
        @cancel="onListCancel"
      />
    </van-popup>
    <!-- 位置选择 -->
    <van-popup
      v-model="locationPickerShow"
      position="bottom"
      class="locationPickerBox"
    >
      <select-location
        @setData="changeArea"
        :locationSource="locationSource"
      ></select-location>
    </van-popup>
  </div>
</template>
<script>
/*eslint-disable*/
const refreshPage = () => import("@/components/common/refreshPage");
const selectLocation = () => import("@/components/common/selectLocation");
import { getAllYears } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import nonePng from "@/assets/none.png";
import { mapState } from "vuex";
export default {
  name: "orgAssessNew",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      nonePng: nonePng, //默认图片
      userZqCode: "",
      userZqName: "",
      userZqLevel: "",
      selectListInfo: "组织机构",
      selectListType: "org",
      allRankList: [],
      rankDataList: [],
      listData: [
        { name: "组织机构", code: "org" },
        { name: "政区", code: "region" },
        { name: "责任区", code: "grid" },
      ],
      locationAddress: "",
      listPickerShow: false,
      locationPickerShow: false,
      changeAddress: "",
      locationSource: {
        zqName: "",
        zqCode: "",
        gridLevel: "",
      },
      page: 0,
      pageSize: 500,
      commentCount: 0,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      isLoading: false, //是否处于下拉刷新状态
      clientType: "", //手机类型
    };
  },
  components: {
    selectLocation,
  },
  mounted() {
    this.$nextTick(() => {
      this.clientType = getDeviceType();
      if (this.userinfo && this.userinfo.zqCode) {
        this.locationAddress = this.userinfo.zqName;
        this.userZqName = this.userinfo.zqName;//_this.userinfo.uidName.gridName;
        this.userZqCode = this.userinfo.zqCode;
        this.userZqLevel = this.userinfo.zqLevel;
      }
    });
  },
  methods: {
    checkOrgPicker() {
      this.listPickerShow = true;
    },
    onListConfirm(data) {
      console.log(data);
      this.listPickerShow = false;
      this.selectListInfo = data.name;
      this.selectListType = data.code;
      this.onLoad();
    },
    onListCancel() {
      this.listPickerShow = false;
    },
    onLoad() {
      // 异步更新数据
      let _this = this;
      _this.page = 0;
      _this.pageSize = 500;
      _this.commentCount = 0;
      _this.loading = false; //是否处于加载状态
      _this.allRankList = [];
      _this.rankDataList = [];
      this.$nextTick(() => {
        if (this.userinfo.zqCode && this.userinfo.uid) {
          this.getDataList();
        }
      });
    },
    changeLocation() {
      let _this = this;
      _this.locationSource.zqName = _this.userZqName;
      _this.locationSource.zqCode = _this.userinfo.zqCode;
      _this.locationSource.gridLevel = _this.userZqLevel;
      if (parseFloat(_this.locationSource.gridLevel) < 5) {
        _this.locationPickerShow = true;
      } else {
        _this.$toast("当前为村级，已无下级政区");
      }
    },
    changeArea(data) {
      console.log(data);

      let arrNames = data.zqName.split("/");
      this.locationAddress = arrNames[arrNames.length - 1];
      this.userZqName =
        data.zqName == "重置选择" ? this.userinfo.zqName : data.zqName;
      this.userZqCode = data.zqCode;
      this.locationPickerShow = false;
      this.onLoad();
    },
    getDataList() {
      let _this = this;
      let total = _this.allRankList.length;
      if (_this.page != 0 && this.page * 500 >= parseInt(_this.commentCount)) {
        return;
      }
      _this.page += 1;

      _this.$api.linLong.detail
        .getKpiFormScoreList(_this.page, _this.pageSize, _this.selectListType, {
          zqCode: _this.userZqCode,
        })
        .then((res) => {
          if (res.code == "1") {
            let total = parseInt(res.data.total);
            _this.commentCount = total;
            _this.rankDataList = res.data.list;
            _this.viewLists();
            // 加载状态结束
            _this.loadingShow = false;
            _this.loading = false;
            if (_this.page * 500 >= total) {
              _this.finished = true;
            }
          } else {
            // _this.$toast(res.msg);
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    viewLists() {
      this.allRankList = this.allRankList.concat(this.rankDataList);
    },
  },
  computed: {
    ...mapState(["userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function () {
        let _this = this;

        _this.locationAddress = _this.userinfo.zaName;
        _this.userZqName = this.userinfo.zqName;
        // _this.userZqName = _this.userinfo.uidName.gridName;
        _this.userZqCode = _this.userinfo.zqCode;
        _this.userZqLevel = _this.userinfo.zqLevel;

        _this.onLoad();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.orgAssessPageNew {
  width: 100%;
  height: 100%;
  p.fgx {
    width: 100%;
    height: 12px;
    background-color: #f6f6f6;
  }
  .swiperHeader {
    position: relative;
    padding: 0 16px;
    width: 100%;
    height: 50px;
    border-bottom: 1px solid #ebedf0;
    > p {
      text-align: center;
      line-height: 50px;
      font-size: 15px;
      font-family: "PingFangSC-Medium", "PingFang SC";
      color: #333;
      font-weight: 600;
    }
    .selectTimes {
      font-size: 15px;
      color: #727272;
      position: absolute;
      top: 16px;
      right: 40px;
      .sanjiao {
        transform: rotate(90deg);
        -ms-transform: rotate(90deg); /* IE 9 */
        -moz-transform: rotate(90deg); /* Firefox */
        -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
        -o-transform: rotate(90deg); /* Opera */
        position: absolute;
        top: 2px;
        right: -20px;
      }
    }
    .selectPositionBox {
      font-size: 15px;
      width: 110px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #727272;
      position: absolute;
      top: 16px;
      left: 20px;
      .van-icon {
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .effectRanking {
    width: 100%;
    height: calc(100% - 62px);

    .rankTop {
      height: 100%;
      position: relative;
      .nonePage {
        width: 120px;
        height: 150px;

        position: absolute;
        left: 50%;
        margin-left: -60px;
        top: 50%;
        margin-top: -75px;

        img {
          display: block;
          max-width: 100px;
          max-height: 100px;
          margin: 0 auto;
        }

        p {
          margin-top: 10px;
          text-align: center;
          color: #5c5d5d;
          font-size: 16px;
        }
      }
      .listBox {
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        .topListInfo {
          min-height: 65px;
          color: #666;
          position: relative;

          p.tit {
            width: 30px;
            font-size: 14px;
            text-align: center;
            margin-right: 10px;
            span {
              line-height: 30px;
              font-weight: 600;
              img {
                max-width: 30px;
                max-height: 30px;
              }
            }
          }
          .progressBox {
            width: 80%;
            height: 30px;
            > p {
              font-family: "PingFangSC-Regular", "PingFang SC";
              em:first-child {
                font-size: 14px;
                color: #333;
              }
              em:nth-child(2) {
                font-weight: 400;
                font-size: 12px;
                color: #959595;
              }
            }
            .vanProgress {
              width: 90%;
              margin-top: 5px;
              height: 6px;
            }
          }
          .itemPoints {
            position: absolute;

            right: 0;
            bottom: 0;
            color: #666;
          }
        }
      }
    }
  }
  .locationPickerBox {
    width: 100%;
    height: 100%;
    background-color: #fff;
    z-index: 999;
  }
}
</style>